/**
 * O que o webchat produziu: números e contatos.
 *
 * Os dois eram abas da coluna lateral, e os dois são **tabelas** — a forma que pior sobrevive a 384px
 * de largura. A de análise tinha três colunas em 40 caracteres; a de contatos nem tabela era, tinha
 * virado uma pilha de cards com `<dl>` dentro, em que comparar dois contatos exigia rolar entre eles.
 *
 * Aqui os dois convivem numa tela só porque respondem a mesma pergunta em dois níveis: **quanto** o
 * fluxo rendeu (agregado, sem dado pessoal) e **quem** veio dele (individual, com dado pessoal). A
 * separação entre os dois continua sendo real — a coleta de contatos tem interruptor próprio e pode
 * estar desligada com os números correndo normalmente —, e é por isso que são duas abas e não uma
 * página rolada: dado pessoal não se abre por acidente ao rolar.
 */

import { useState } from 'react';
import { AnalyticsPanel } from '../components/data/AnalyticsPanel.js';
import { LeadsPanel } from '../components/data/LeadsPanel.js';
import { IconeDados, IconeLeads } from '../components/icons.js';
import { tabId, Tabs } from '../components/ui.js';

type Painel = 'analise' | 'contatos';

const PAINEL_ID = 'painel-de-dados';

const ABAS: { id: Painel; label: string; icon: typeof IconeDados }[] = [
  { id: 'analise', label: 'Análise', icon: IconeDados },
  { id: 'contatos', label: 'Contatos', icon: IconeLeads },
];

export function DataPage() {
  const [aba, setAba] = useState<Painel>('analise');

  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <div className="mx-auto max-w-6xl px-6 py-8">
        <div className="mb-6">
          <Tabs<Painel> tabs={ABAS} active={aba} onChange={setAba} panelId={PAINEL_ID} />
        </div>

        <div id={PAINEL_ID} role="tabpanel" aria-labelledby={tabId(aba)}>
          {aba === 'analise' ? <AnalyticsPanel /> : <LeadsPanel />}
        </div>
      </div>
    </div>
  );
}
